// base
import { useCallback } from 'react';

// modules
import { CurrentMenuAtom, MenuListAtom } from 'modules';
import { UserIdAtom, UserInfoAtom, UserRolesAtom } from 'modules/user/atoms/user.atom';

// libraries
import { useResetRecoilState } from 'recoil';

export const useResetRecoil = () => {
  const resetUserId = useResetRecoilState(UserIdAtom);
  const resetUserRoles = useResetRecoilState(UserRolesAtom);
  const resetUserInfo = useResetRecoilState(UserInfoAtom);
  const resetMenuList = useResetRecoilState(MenuListAtom);
  const resetCurrentMenu = useResetRecoilState(CurrentMenuAtom);

  const onResetAllRecoil = useCallback(() => {
    resetUserId();
    resetUserRoles();
    resetUserInfo();
    resetMenuList();
    resetCurrentMenu();
  }, [resetUserId, resetUserRoles, resetUserInfo, resetMenuList, resetCurrentMenu]);

  const onResetRecoil = (recoilKey: string) => {
    switch (recoilKey) {
      case 'UserIdAtom':
        resetUserId();
        break;
      case 'UserRolesAtom':
        resetUserRoles();
        break;
      case 'UserInfoAtom':
        resetUserInfo();
        break;
      case 'MenuListAtom':
        resetMenuList();
        break;
      case 'CurrentMenuAtom':
        resetCurrentMenu();
        break;
      default:
        break;
    }
  };

  return { onResetRecoil, onResetAllRecoil };
};
